export type FootprintCursorContext = {
  isPolygonClosed: boolean;
  hoveredPointIndex: number | null;
  hoveredEdgeIndex: number | null;
  isHoveringFill: boolean;
  pointsLength: number;
  isDragging: boolean;
  hasCursorPosition: boolean;
  vertexDragMode?: 'move' | 'scale';
};

const EDGE_TOOLTIP_LINES = ['[drag] move', '[click] add point'] as const;
const POINT_TOOLTIP_LINES = ['[drag] move', '[click] delete'] as const;
const POINT_SCALE_TOOLTIP_LINES = ['[drag] resize', '[click] delete'] as const;
const FILL_TOOLTIP_LINES = [
  '[drag] move',
  '[drag to sidebar] delete shape'
] as const;
const ADD_POINT_TOOLTIP_LINES = ['add point'] as const;

export function getFootprintCursorTooltipLines(
  ctx: FootprintCursorContext
): readonly string[] | null {
  if (ctx.isDragging) return null;

  if (ctx.isPolygonClosed) {
    if (ctx.hoveredPointIndex !== null) {
      return ctx.vertexDragMode === 'scale'
        ? POINT_SCALE_TOOLTIP_LINES
        : POINT_TOOLTIP_LINES;
    }
    if (ctx.hoveredEdgeIndex !== null) return EDGE_TOOLTIP_LINES;
    if (ctx.isHoveringFill) return FILL_TOOLTIP_LINES;
    return null;
  }

  if (!ctx.hasCursorPosition) return null;

  const isCloseablePoint = ctx.hoveredPointIndex === 0 && ctx.pointsLength >= 3;
  if (isCloseablePoint) return null;

  return ADD_POINT_TOOLTIP_LINES;
}

export type FootprintOutlineEditorTooltipArgs = {
  interactive: boolean;
  isDragging: boolean;
  hoveredVertexIndex: number | null;
  hoveredEdgeIndex: number | null;
  isHoveringFill: boolean;
  pointsLength: number;
  hasCursorPosition: boolean;
  vertexEdited: boolean;
};

export function getFootprintOutlineEditorTooltipLines(
  args: FootprintOutlineEditorTooltipArgs
): readonly string[] | null {
  if (!args.interactive) return null;
  return getFootprintCursorTooltipLines({
    isPolygonClosed: true,
    hoveredPointIndex: args.hoveredVertexIndex,
    hoveredEdgeIndex: args.hoveredEdgeIndex,
    isHoveringFill: args.isHoveringFill,
    pointsLength: args.pointsLength,
    isDragging: args.isDragging,
    hasCursorPosition: args.hasCursorPosition,
    vertexDragMode: args.vertexEdited ? 'move' : 'scale'
  });
}
